import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { tID } from '../../utils/utils'

export interface TrophyIconProps {
  height?: number
  width?: number
  fillColor?: string
}

export const TrophyIcon: FunctionComponent<TrophyIconProps> = ({ height = 14, width = 14, fillColor, ...rest }) => {
  const { colors } = useTheme()
  const fill = fillColor || colors.icons.trophyIcon.fill

  return (
    <Svg testID={tID('TrophyIcon')} width={width} height={height} viewBox='0 0 14 14' fill='none' {...rest}>
      <Path
        fill={fill}
        d='M9.992 7.435h.068l.585-.232a4.41 4.41 0 0 0 2.79-4.118 1.687 1.687 0 0 0-2.07-1.643v-.18a.556.556 0 0 0-.563-.614H3.176a.555.555 0 0 0-.563.614v.18a1.666 1.666 0 0 0-.382-.044A1.688 1.688 0 0 0 .565 3.07a4.41 4.41 0 0 0 2.79 4.117l.585.233h.067c.37.55.847 1.02 1.403 1.38v.615a.562.562 0 0 1-.563.563 2.31 2.31 0 0 0-2.302 2.302v.51a.563.563 0 0 0 .562.563h7.77a.563.563 0 0 0 .563-.563v-.51A2.31 2.31 0 0 0 9.137 10a.562.562 0 0 1-.562-.563v-.614a4.912 4.912 0 0 0 1.417-1.388Zm1.74-4.935a.562.562 0 0 1 .563.563 3.3 3.3 0 0 1-1.553 2.797c.139-.432.232-.877.278-1.328l.165-1.627a.562.562 0 0 1 .547-.405ZM1.69 3.07a.562.562 0 0 1 1.095-.165l.165 1.627c.051.452.149.897.292 1.328A3.3 3.3 0 0 1 1.69 3.07Zm7.447 8.047a1.177 1.177 0 0 1 1.178 1.133H3.67a1.178 1.178 0 0 1 1.177-1.125 1.687 1.687 0 0 0 1.688-1.688V8.5a.578.578 0 0 0-.3-.503A4.5 4.5 0 0 1 4.067 4.42L3.932 3.1a1.687 1.687 0 0 0-.052-.39l-.083-.96h6.39l-.09.922c-.032.128-.05.259-.052.39L9.917 4.42a4.5 4.5 0 0 1-2.175 3.57.578.578 0 0 0-.3.502v.938a1.687 1.687 0 0 0 1.695 1.688Z'
      />
    </Svg>
  )
}
